module.exports = __webpack_public_path__ + "img/morentouxiang@2x.cb37706a.png";